<!-- 创建赛程 主题还没调通，因为世界杯还没有设置赛程主题；但晋级图已经调通；因此该页面目前除了创建赛程不能分享以外其他功能应该都正常 -->
<template>
  <div id="cup_schedule" v-show="currThemeObj">
    <div class="abs_topArea">淘汰赛</div>

    <div
      class="match_list"
      v-show="!isNotDataFlag"
      ref="scheMatchList_for_locationGroupItem"
    >
      <div
        class="publishBtn_row"
        v-id="
          MultipleChoiceSharingMenuRow_list &&
          MultipleChoiceSharingMenuRow_list.length > 0
        "
      >
        <MultipleChoiceSharingMenuRow
          :list="MultipleChoiceSharingMenuRow_list"
          :baseOpt="MultipleChoiceSharingMenuRow_baseOpt"
          @clickMenuEvent="MultipleChoiceSharingMenuRow_clickMenuHandler"
          @clickPublicThemeEvent="
            MultipleChoiceSharingMenuRow_clickPublicThemeHandler
          "
        ></MultipleChoiceSharingMenuRow>
      </div>
      <HTML_KNOCKOUT_T4T6T8
        v-show="stageType == 2"
        :currThemeObj="currThemeObj"
        :datas="origin_knockoutList"
        :detailPathName="`scheduleDetailIndex_${currThemeObj.moduleRouteNameEn}`"
      ></HTML_KNOCKOUT_T4T6T8>
    </div>
    <cup_notData className="relativePtb60" v-show="isNotDataFlag"></cup_notData>
  </div>
</template>

<script>
// import matchList_mock from './matchList_mock.json'
import { https_cup_groupScheduleList } from '@api/platfrom_football_api'
import { https_basketballCup_knockoutData } from '@api/platfrom_basketball_api'
import HTML_KNOCKOUT_T4T6T8 from '@components/football/html/HTML_KNOCKOUT/teamsForT4OrT6OrT8.vue'
import cup_notData from '@components/base/NO_DATA.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import multipleChoiceShare_data_mixin from '@mixins/multipleChoiceShare_data'
import MultipleChoiceSharingMenuRow from '@components/base/theme/multipleChoiceSharingMenuRow.vue'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
// import knockout_page from './knockout.vue'
export default {
  name: 'cup_schedule',
  components: {
    HTML_KNOCKOUT_T4T6T8,
    cup_notData,
    MultipleChoiceSharingMenuRow,
  },
  mixins: [
    cup_base_data_mixin,
    multipleChoiceShare_data_mixin,
    single_findAnalysisItem_data_mixin,
  ],
  data() {
    return {
      // themeTemplateType: null, // 今日赛程 主题
      basketballCupCidArr: ['202', '203'],
      themeTemplateTypeArr: [27, 8], // 晋级图 主题
      themeTemplateType: 8, // 晋级图 主题
      isNotDataFlag: false,
      themeList: [],
      origin_matchList: [],
      matchList: [],
      origin_knockoutList: { data: { dataList: [] } },
      knockoutList: [],
      stageType: 2,
      MultipleChoiceSharingMenuRow_baseOpt: {
        openMenuWidthVw: '22.2vw', // 打开的总宽度
        closeMenuWidthVw: '6.4vw', // 收起来的总宽度
      },
      MultipleChoiceSharingMenuRow_list: [],
      // MultipleChoiceSharingMenuRow_list: [
      //   {
      //     id: 'top4',
      //     name: '四强晋级',
      //     isAct: false,
      //   },
      //   {
      //     id: 'top8',
      //     name: '八强晋级',
      //     isAct: false,
      //   },
      // ],
      multipleChoiceShareFixedBtn_modeType: {
        btnName: '创建赛程',
        localStorageName: 'mixtmt_choose_scheduleThomasAndUber',
        unit: '场',
      },
      scheduleMatchList_matchMode: {
        mode: 'FIFAWorldCup',
        type: 'matchDate',
        filterCondition: 'team_-1',
      },
    }
  },
  created() {
    if (this.currGroup) {
      this.init()
    }
  },
  computed: {
    noData() {
      return this.matchList && this.matchList.length === 0
    },
  },
  methods: {
    async init() {
      // this.origin_matchList = matchList_mock.data
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug(this.currCid, this.currSid)
      const sportTypeArr = ['basketball', 'football']
      if (this.currThemeObj) {
        const index = sportTypeArr.indexOf(this.currThemeObj.sportType)
        this.themeTemplateType = this.themeTemplateTypeArr[index]
      }
      // 主题和数据暂未分开 && 后端还未加世界杯赛程
      // if (this.initFindanalysisItem && (!this.themeItem || !this.crossSeason)) {
      //   this.initFindanalysisItem()
      // }
      this.makeAnalysisItemParams(this.themeTemplateType)
      if (this.basketballCupCidArr.includes(this.currCid)) {
        await this.getBasketballCupKnockoutData()
      } else {
        await this.getGroupScheduleList()
      }
      //   this.$nextTick(() => {
      //     if (curDateIndex > -1) {
      //       let curDateDom =
      //         this.$refs.scheMatchList_for_locationGroupItem.children[
      //           curDateIndex
      //         ]
      //       console.debug(
      //         'curDateIndex:',
      //         curDateDom.offsetTop,
      //         this.$px(8, this.clientWidth)
      //       )
      //       this.goBackTop([
      //         0,
      //         curDateDom.offsetTop - Math.ceil(this.$px(8, this.clientWidth)),
      //       ])
      //     }
      //   })

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      console.debug('makeAnalysisItemParams')
      this.findAnalysisItemParams = {
        sportType: 'football',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0,
        eid: 0,
        pid: 0,
        mid: 0,
      }
      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
    },
    MultipleChoiceSharingMenuRow_clickMenuHandler(item) {
      this.MultipleChoiceSharingMenuRow_list.forEach((menuItem, meunIndex) => {
        if (item.id === menuItem.id) {
          menuItem.isAct = true
          this.themeItem = this.themeList[meunIndex]
        } else {
          menuItem.isAct = false
        }
      })
    },
    MultipleChoiceSharingMenuRow_clickPublicThemeHandler(item) {
      let themeItem = this.themeItem
      if (themeItem) {
        this.clickPublicTheme(themeItem)
      } else {
        console.error('没有找到对应分享的主题数据：themeItem')
      }
    },
    findAnalysisItemCallback(resData) {
      // let themeAnalysisItemIdArr = []
      console.debug('findAnalysisItemCallback:', resData)
      let jsonArr = []
      let towTitleNameNumber = 0
      this.MultipleChoiceSharingMenuRow_list = [];
      if (resData && resData.length > 0) {
        const themeList_length = resData.length
        this.themeList = resData.map((item, index) => {
          // themeAnalysisItemIdArr.push(item.analysisItemId)
          towTitleNameNumber += item.twoTitle.length
          this.MultipleChoiceSharingMenuRow_list.push({
            id: `top${index}`,
            name: item.twoTitle,
            isAct: false,
          })
          // this.MultipleChoiceSharingMenuRow_list[index].name = item.twoTitle
          console.debug(`aa: ${item}`)
          jsonArr.push(item.json)
          item.actJson = JSON.parse(item.json)
          item.renderData = null
          return item
        })
        this.MultipleChoiceSharingMenuRow_baseOpt = {
          openMenuWidthVw: `${
            6.4 + 1.2 * towTitleNameNumber + themeList_length * (2.2 + 1.2)
          }vw`, // 打开的总宽度
          closeMenuWidthVw: '6.4vw', // 收起来的总宽度
        }
        this.MultipleChoiceSharingMenuRow_clickMenuHandler(
          this.MultipleChoiceSharingMenuRow_list[themeList_length - 1]
        )
      }
    },
    changeChooseNumEventHandler(data) {
      // 这个是多选分享每个.vue文件根据数据结构，单独写的
      if (data.init) {
        // 清除缓存，重新开始
        this.$localStorage.removeItem(
          data.localStorageName //this.multipleChoiceShareFixedBtn_modeType.localStorageName
        )
        // multipleChoiceShare_fixedBtn 组件清除缓存数据时，源数据是否要重置
        this.matchList.forEach((dateItem) => {
          if (dateItem.list) {
            dateItem.list.forEach((match) => {
              match.isChooseFlag = false
            })
          }
        })
      } else {
        const chooseSchedule = JSON.parse(
          this.$localStorage.getItem(
            data.localStorageName //this.multipleChoiceShareFixedBtn_modeType.localStorageName
          )
        )
        console.debug('data.type:', data, chooseSchedule)
        let matchList = JSON.parse(JSON.stringify(this.matchList))
        matchList.forEach((dateItem) => {
          if (dateItem.list) {
            dateItem.list.forEach((item) => {
              if (chooseSchedule.chooseIdArr.includes(item.chooseId)) {
                item.isChooseFlag = true
              } else {
                item.isChooseFlag = false
              }
            })
          }
        })
        this.matchList = matchList
        this.$localStorage.setItem(
          data.localStorageName,
          JSON.stringify(chooseSchedule)
        )
        this.localStorageChooseList = chooseSchedule.chooseItemArr
      }
      this.smallBtnArr.forEach((item) => {
        if (item.type === 'check') {
          item.val = data.val
        }
      })
    },
    async getGroupScheduleList() {
      if (this.isNotDataFlag) {
        this.isNotDataFlag = false
      }
      await https_cup_groupScheduleList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
        stage: this.stageType,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (!res.data || (res.data && res.data.length == 0)) {
              this.isNotDataFlag = true
            }
            this.origin_knockoutList = res.data
              ? { data: { dataList: res.data } }
              : { data: { dataList: [] } }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getBasketballCupKnockoutData() {
      if (this.isNotDataFlag) {
        this.isNotDataFlag = false
      }
      await https_basketballCup_knockoutData(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        cid: this.currCid,
        stage: this.stageType,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (!res.data || (res.data && res.data.length == 0)) {
              this.isNotDataFlag = true
            }
            this.origin_knockoutList = res.data
              ? { data: { dataList: res.data } }
              : { data: { dataList: [] } }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#cup_schedule {
  .publishBtn_row {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 4.16vw;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    /* .theme_publishBtn {
        width: 4.16vw;
        text-align: center;
        svg.publishBtn_icon {
          fill: var(--mixtmt_greyColor4);
        }
      } */
    .shareBtnArea {
      margin-left: 1.388vw;
      width: 9.74vw;
      height: 3.2vw;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      background-color: var(--mixtmt_subColor1_1);
      border: 1px solid var(--mixtmt_subColor1_1);
      border-radius: 0.347vw;
      color: var(--mixtmt_whiteColor);
      transition: all 0.3s linear;
      .shareBtn {
        font-size: 1.11vw;
      }
      .publishBtn {
        width: 1.8vw;
        text-align: center;
        svg.publishBtn_icon {
          fill: var(--mixtmt_whiteColor);
        }
      }
    }
    .shareBtnArea {
      &:hover {
        cursor: pointer;
        background-color: var(--mixtmt_mainColor);
        border: 1px solid var(--mixtmt_mainColor);
        color: var(--mixtmt_whiteColor);
      }
    }
  }
  .abs_topArea {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 2vw 0 0 9.722vw;
    width: 100%;
    height: 8.68vw;
    font-size: 3vw;
    line-height: 6.68vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_detail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    object-fit: contain;
  }
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .match_list {
    padding-top: 4.16vw;
    position: relative;
  }
}
.mixtmt_pc #cup_schedule,
.mixtmt_ipad #cup_schedule {
  padding: 8.68vw 0 0;
  .theme_publishBtn {
    cursor: pointer;
    &:hover {
      svg.publishBtn_icon {
        fill: var(--mixtmt_subColor1_1);
      }
    }
  }
}
</style>
